import { Divider, LegacyCard, Text, Tooltip } from "@shopify/polaris"
import { observer } from "mobx-react"
import React, { Fragment } from "react"

import { SimpleLine } from "@/components"
import { FormatPriceText } from "@/components"
import stores from "@/stores"

const DisplayList = (props: { hasCompare: boolean; loading: boolean }) => {
  const { hasCompare, loading } = props
  const { ReturnRequestsDataStore, UserInfoStore } = stores
  // 使用 useMemo 缓存 metrics 配置，避免不必要的重渲染
  const metrics = [
    {
      show: ReturnRequestsDataStore.is_open_exchange_other,
      label: t("ExchangesUpsellValue"),
      value: ReturnRequestsDataStore.exchange_upsell_value,
      tooltipContent: t("TheRevenueValueGeneratedFromExchang"),
      charts: ReturnRequestsDataStore.data?.map((item) => {
        return item.current.exchange_upsell_value
      }),
      compateCharts: ReturnRequestsDataStore.data?.map((item) => {
        return item.previous.exchange_upsell_value
      }),
    },
    {
      show: !ReturnRequestsDataStore.is_open_exchange_other,
      label: t("BackInStoreValue"),
      value: ReturnRequestsDataStore.back_in_store_value,
      tooltipContent: ReturnRequestsDataStore.is_open_exchange_other
        ? t("TheTotalValueRetainedFromExchanges")
        : t("TheTotalValueRetainedFromReplacemen"),
      charts: ReturnRequestsDataStore.data?.map((item) => {
        return item.current.back_in_store_value
      }),
      compateCharts: ReturnRequestsDataStore.data?.map((item) => {
        return item.previous.back_in_store_value
      }),
    },
    {
      show: true,
      label: t("ReturnRequests"),
      value: ReturnRequestsDataStore.requests_count,
      tooltipContent: t("TheTotalNumberOfReturnRequestsCrea"),
      charts: ReturnRequestsDataStore.data?.map((item) => {
        return item.current.request_count
      }),
      compateCharts: ReturnRequestsDataStore.data?.map((item) => {
        return item.previous.request_count
      }),
    },
    {
      show: true,
      label: t("ReturnRate"),
      value: ReturnRequestsDataStore.total_return_rate,
      tooltipContent: t("ThePercentageOfItemsReturnedToYour"),
      charts: ReturnRequestsDataStore.data?.map((item) => {
        return item.current.return_rate
      }),
      compateCharts: ReturnRequestsDataStore.data?.map((item) => {
        return item.previous.return_rate
      }),
    },
  ]
  return (
    <div className="flex justify-between items-center gap-4 my-4 flex-wrap">
      {metrics
        .filter((item) => item.show)
        .map((item, index) => {
          return (
            <div className="flex-1">
              <LegacyCard>
                <LegacyCard.Section key={item.label}>
                  <div key={`metric-${index}`} className="flex-1 space-y-3">
                    <Tooltip
                      content={item.tooltipContent}
                      preferredPosition="above"
                    >
                      <span
                        style={{
                          borderBottom: "2px dotted #CECECE",
                        }}
                        className="whitespace-nowrap inline-block cursor-pointer"
                      >
                        <Text variant="headingSm" as="span">
                          {item.label}
                        </Text>
                      </span>
                    </Tooltip>
                    <div className="flex justify-between gap-2">
                      <Text variant="headingLg" as="p">
                        {item.label === t("ReturnRequests") ? (
                          item.value
                        ) : item.label === t("ReturnRate") ? (
                          <span>{item.value > 0 ? item.value : "0.00"}%</span>
                        ) : (
                          <FormatPriceText
                            value={item.value}
                            currency={UserInfoStore.data.currency_format}
                          />
                        )}
                      </Text>
                      <div className="h-6 w-24">
                        {!loading && (
                          <SimpleLine
                            data={item.charts || []}
                            compareData={
                              hasCompare ? item.compateCharts || [] : []
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </LegacyCard.Section>
              </LegacyCard>
            </div>
          )
        })}
    </div>
  )
}

export default observer(DisplayList)
